module.exports = __webpack_public_path__ + "img/01_abe_14.1af44f5e.jpg";